export default function FetchAthleteGamelog(termId, statKey, statId) {
    const data = new FormData();
    data.append('action', 'get_athlete_gamelog');
    data.append('term_id', Math.abs(termId));
    data.append('stat_id', Math.abs(statId));
    data.append('stat_key', statKey);

    return fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: data
    })
    .then(response => response.json())
    .then(result => {
        if (result.success) {
          return result.data;
        } else {
            console.error('Error fetching gamelog:', result.data);
            return [];
        }
    })
    .catch(error => {
        console.error('Fetch error:', error);
        return [];
    });
  }